// services/authService.js
import Cookies from "js-cookie";
import { HttpApiClient } from "../axios/axiosInstance";

const AUTH_ENDPOINTS = {
  register: "/user/register",
  login: "/user/login",
};

// Register user
export const registerUser = async (userData) => {
  try {
    const response = await HttpApiClient.post(
      AUTH_ENDPOINTS.register,
      userData
    );

    // Access nested payload structure
    const { payload } = response.data;

    // If registration includes token, store it
    if (payload?.token) {
      setAuthToken(payload.token);
    }

    // Store user data if provided
    if (payload?.user) {
      setUserData(payload.user);
    }

    return payload; // Return the payload, not response.data
  } catch (error) {
    throw new Error(error.response?.data?.message || "Registration failed");
  }
};

// Login user
export const loginUser = async (credentials) => {
  try {
    const response = await HttpApiClient.post(
      AUTH_ENDPOINTS.login,
      credentials
    );

    // Access nested payload structure
    const { payload } = response.data;

    // Store token
    if (payload?.token) {
      setAuthToken(payload.token);
    }

    // Store user data
    if (payload?.user) {
      setUserData(payload.user);
    }

    return payload; // Return the payload, not response.data
  } catch (error) {
    throw new Error(error.response?.data?.message || "Login failed");
  }
};

// Token management
export const setAuthToken = (token) => {
  Cookies.set("accessToken", token, {
    expires: 7, // 7 days
    secure: process.env.NODE_ENV === "production",
    sameSite: "strict",
  });
};

export const getAuthToken = () => {
  return Cookies.get("accessToken");
};

export const removeAuthToken = () => {
  Cookies.remove("accessToken");
  Cookies.remove("refreshToken");
  Cookies.remove("user");
};

// User data management
export const setUserData = (user) => {
  Cookies.set("user", JSON.stringify(user), {
    expires: 7,
    secure: process.env.NODE_ENV === "production",
    sameSite: "strict",
  });
};

export const getUserData = () => {
  const userData = Cookies.get("user");
  return userData ? JSON.parse(userData) : null;
};

// Check if user is authenticated
export const isAuthenticated = () => {
  const token = getAuthToken();
  if (!token) return false;

  try {
    // Basic JWT validation
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp > Date.now() / 1000;
  } catch {
    return false;
  }
};

// Logout user
export const logoutUser = () => {
  removeAuthToken();
  window.location.href = "/login";
};

// Get user info from token (fallback if no user cookie)
export const getUserFromToken = () => {
  const token = getAuthToken();
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return {
      id: payload.userId, // Your JWT uses 'userId', not 'id'
      email: payload.email,
      firstName: payload.first_name,
      lastName: payload.last_name,
    };
  } catch {
    return null;
  }
};
